export const agg_1 = {
	agg_1_1: require('@/assets/images/agg/1/1.png'),
	agg_1_2: require('@/assets/images/agg/1/2.png'),
	agg_1_3: require('@/assets/images/agg/1/3.png'),
};

export const agg_2 = {
	agg_2_1: require('@/assets/images/agg/2/1.png'),
	agg_2_2: require('@/assets/images/agg/2/2.png'),
};

export const agg_3 = {
	agg_3_1: require('@/assets/images/agg/3/1.png'),
	agg_3_2: require('@/assets/images/agg/3/2.png'),
};